// The token sent with requests: the mascarade one while browsing as someone else.
export const getAuthToken = () =>
  localStorage.getItem("mascarade_token") || localStorage.getItem("token");
